export enum TransferType {
  Previous = 'previous',
  Next = 'next',
  New = 'new',
}
